<app-header></app-header>
<div *ngIf="isSubmitting" class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
    <div class="bg-white p-6 rounded-lg shadow-lg">Loading...</div>
  </div>
<div class="auth-container flex flex-col lg:flex-row" style="margin-top: -30px;">
        <!-- Left Side (Branding) - Hidden on mobile -->
        <div class="hidden lg:flex lg:w-1/2 bg-gradient-to-br from-wattpad-primary to-wattpad-secondary items-center justify-center p-12">
            <div class="max-w-md text-center text-white">
                <h1 class="text-4xl font-bold mb-6">Welcome Back!</h1>
                <p class="text-lg mb-8">Continue your reading journey with millions of stories waiting for you.</p>
                <div class="flex justify-center space-x-4">
                    <div class="bg-white/20 p-3 rounded-full">
                        <i class="fas fa-book-open text-xl"></i>
                    </div>
                    <div class="bg-white/20 p-3 rounded-full">
                        <i class="fas fa-heart text-xl"></i>
                    </div>
                    <div class="bg-white/20 p-3 rounded-full">
                        <i class="fas fa-users text-xl"></i>
                    </div>
                </div>
            </div>
        </div>

        <!-- Right Side (Form) -->
        <div class="w-full lg:w-1/2 flex items-center justify-center p-6 lg:p-12">
            <div class="w-full max-w-md">
                <div class="text-center lg:hidden mb-8">
                    <h1 class="text-3xl font-bold text-wattpad-primary mb-2">StoryVerse</h1>
                    <p class="text-wattpad-light">Log in to continue reading</p>
                </div>

                <div class="bg-white dark:bg-gray-800 rounded-xl shadow-sm p-6 lg:p-8">
                    <h2 class="text-2xl font-bold mb-6">Forgot Password</h2>
                    
                      <p *ngIf="message" class="text-green-600 mb-3">{{ message }}</p>
  <p *ngIf="error" class="text-red-600 mb-3">{{ error }}</p>

  <form (ngSubmit)="onSubmit()">
    <div class="mb-4">
      <label>Email Address</label>
      <input type="email" [(ngModel)]="email" name="email" required class="w-full px-4 py-3 rounded-lg border border-gray-300 dark:border-gray-700 focus:outline-none focus:ring-2 focus:ring-wattpad-primary focus:border-transparent dark:bg-gray-700" />
    </div>
    <button type="submit" class="w-full bg-wattpad-primary text-white py-2 rounded hover:bg-[#E5274B]">
      Send Reset Link
    </button>
    <div class="text-center mt-4">
      <a (click)="backToLogin()" class="text-sm text-wattpad-primary hover:underline cursor-pointer">Back to Login</a>
    </div>
  </form>
                </div>
            </div>
        </div>
    </div>

    <!-- Mobile Bottom Navigation -->
    <nav class="bottom-nav fixed bottom-0 left-0 right-0 bg-white dark:bg-gray-800 border-t border-gray-200 dark:border-gray-700 lg:hidden">
        <div class="flex justify-around items-center h-full">
            <a href="index4.html" class="text-gray-500 dark:text-gray-400 flex flex-col items-center">
                <i class="fas fa-home text-xl"></i>
                <span class="text-xs mt-1">Home</span>
            </a>
            <a href="#" class="text-gray-500 dark:text-gray-400 flex flex-col items-center">
                <i class="fas fa-search text-xl"></i>
                <span class="text-xs mt-1">Search</span>
            </a>
            <a href="#" class="text-gray-500 dark:text-gray-400 flex flex-col items-center">
                <i class="fas fa-bookmark text-xl"></i>
                <span class="text-xs mt-1">Library</span>
            </a>
            <a href="#" class="text-wattpad-primary flex flex-col items-center">
                <i class="fas fa-user text-xl"></i>
                <span class="text-xs mt-1">Profile</span>
            </a>
        </div>
    </nav>

